module.exports = __webpack_public_path__ + "media/icons/down-table-arrow-68e680a9.png";